import { render } from "./uploadFace.vue?vue&type=template&id=7c6bb27e&scoped=true"
import script from "./uploadFace.vue?vue&type=script&lang=js"
export * from "./uploadFace.vue?vue&type=script&lang=js"

import "./uploadFace.vue?vue&type=style&index=0&id=7c6bb27e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6bb27e"]])

export default __exports__